import React, { memo } from 'react';
import { Skeleton } from '@fourthwall/components';
import * as S from './styled';
export const OptionsSkeleton = memo(() => (React.createElement(Skeleton, null,
    React.createElement(S.List, null,
        React.createElement(S.Item, null,
            React.createElement(Skeleton.Shape, { width: "60%", height: 16 }),
            React.createElement(Skeleton.Shape, { width: "15%", height: 12 })),
        React.createElement(S.Item, null,
            React.createElement(Skeleton.Shape, { width: "70%", height: 16 }),
            React.createElement(Skeleton.Shape, { width: "20%", height: 12 })),
        React.createElement(S.Item, null,
            React.createElement(Skeleton.Shape, { width: "65%", height: 16 }),
            React.createElement(Skeleton.Shape, { width: "25%", height: 12 }))))));
